/**
 * This is used for resellers that do not have the topup
 * flag active.  This will be deprecated when budgets are rolled out generally
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 

import PropTypes from 'prop-types';
import { Grid, Paper, Slider, Tooltip, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import HelpOutline from '@mui/icons-material/HelpOutline';


import ServerError from '../ui/ServerError';

import CurrencyTextField from '../ui/CurrencyTextField';

import LoadingSpinner from '../ui/LoadingSpinner';
import AccountInformationFetch from './AccountInformationFetch';

import SaveButton from '../ui/SaveButton';
import DashboardLimitRequest from '../home/DashboardLimitRequest';
import AutoTopupAccountUpdateMutation from './AutoTopupAccountUpdateMutation';

import PoweredBy from '../landing/PoweredBy';

import { green } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();

/* Need funding sources for the individual topup */
const CustomerChargeLimitQuery = graphql`
query CustomerChargeLimitQuery($accountId: UUID!, $activeOnly: Int, $purpose: Int) {
  paymentsourceswithaggregate7(accountid: $accountId, activeonly: $activeOnly, purpose: $purpose) {
    totalCount
    nodes {
      psId
      psType
      psStatus
      paidMtd
      paidLastMonth
      paidYtd
      paidLifetime
      ccBrand
      ccLast4
      ccExpy
      fiName
      achAccountNum
      firstName
      lastName
      extSource
      extPsId
      paypalEmail
      maxPsOrder
      maxPsOrderIn
      psStatusOther
      declineCount
      lastDeclineReason
      lastDeclineChargeAmount
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  sectionBlock: {
    marginBottom: 12,  
  },
  paper: {
    textAlign: 'left',
    //color: theme.palette.text.secondary,
    maxWidth: 1122,
    marginTop: 16,
    marginBottom: 16,
    paddingTop: 16,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  },
  currencyField: {
    width: 144,
  },
  currencyField2: {
    width: 176,
  },
  currencyField3: {
    width: 88,
    marginTop: 4,
    marginBottom: 4,
    marginRight: 8,
  },
  noBudgetHolder: {
    marginTop: 8,
    marginBottom: 8,
    marginRight: 8,
  },
  currencyFieldSlider: {
    marginLeft: 8,
    width:64,
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 56,
    width: 264
  },
  dbTileSelected: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 56,
    width: 264,
    backgroundColor: '#D3D3D3'
  },
  dbTileNonSelectable: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 312
  },
  success: {
    backgroundColor: green[300],
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },

});

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  let formattedValue = Number(value).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="bottom" title={formattedValue}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
};

function ValueLabelFormat(value) {
  let theVal = value;
  if (isNaN(value))
    theVal = 0;

  return Number(theVal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 0});
}

ValueLabelFormat.propTypes = {
  value: PropTypes.number.isRequired,
};

class CustomerChargeLimit extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      maxMonthlyBudget: null,

      ledgerBalance: 0,

      maxCharge: 0,
      floatLimit: 0,
      origMaxCharge: null,
      origFloatLimit: null,
      origUseBudgets: null,

      requestedMaxCharge: 0,
      requestedFloatLimit: 0,
      origRequestedMaxCharge: null,
      origRequestedFloatLimit: null,

      accountFetched: false,

      showTopOffDialog: false,



      saveStatus: null,
      saveMessage: null,
      saveSnackbarOpen: false,
      saveSnackbarDuration: null,

      saveStatusLimit: null,
      saveMessageLimit: null,
      saveSnackbarOpenLimit: false,
      saveSnackbarDurationLimit: null,

      saveStatusPFB: null,
      saveMessagePFB: null,
      saveSnackbarOpenPFB: false,
      saveSnackbarDurationPFB: null,

      
      saveStatusAddNow: null,
      saveMessageAddNow: null,
      saveSnackbarOpenAddNow: false,
      saveSnackbarDurationAddNow: null,

      activeOnly:  1,
      activeList: '',
      doRefreshCount: 0,

      confirmAutoTopup: false

    };

  }

  componentDidMount() {
 
      const { logError } = this.props.auth;

      //get float information needed for tile
      let accountId = this.props.accountId;

      AccountInformationFetch.fetch(accountId).toPromise()
      .then(aif => {

        let maxMonthlyBudget = null;
        if (aif.accountTByAccountId.maxMonthlyBudget != null) {
        let mmb = parseFloat(aif.accountTByAccountId.maxMonthlyBudget);
          maxMonthlyBudget = Number(mmb).toFixed(2);
        }
        /*
        if (aif.accountTByAccountId.maxMonthlyBudget === null) {
          maxMonthlyBudget = 100;
        } else if (maxMonthlyBudget < 40.00) {
          maxMonthlyBudget = 40;
        }
        */

        this.setState({accountFetched: true, 
                        floatLimit:  Number(aif.accountTByAccountId.floatLimit).toFixed(2),
                        maxCharge:  Number(aif.accountTByAccountId.maxCharge).toFixed(2),
                        origFloatLimit:  Number(aif.accountTByAccountId.floatLimit).toFixed(2),
                        origMaxCharge:  Number(aif.accountTByAccountId.maxCharge).toFixed(2),
                        maxMonthlyBudget: maxMonthlyBudget,
                        origMaxMonthlyBudget: maxMonthlyBudget,
                        requestedMaxCharge: Number(aif.accountTByAccountId.requestedMaxCharge).toFixed(2),
                        requestedFloatLimit: Number(aif.accountTByAccountId.requestedFloatLimit).toFixed(2),
                        origRequestedMaxCharge: Number(aif.accountTByAccountId.requestedMaxCharge).toFixed(2),
                        origRequestedFloatLimit: Number(aif.accountTByAccountId.requestedFloatLimit).toFixed(2)
                      });    

      })
      .catch(err => {
        logError('Exception in CustomerChargeLimit.js: ' + err);
      })

  }
  handleRequestedMaxChargeChange  = (event, newValue) => {
    this.setState({ requestedMaxCharge: newValue});
  }

  handleRequestedFloatLimitChange  = (event, newValue) => {
    this.setState({ requestedFloatLimit: newValue});
  }

  isLimitSaveDisabled(isUserAppbind) {

    if (!isUserAppbind) {
      if ( (parseFloat(this.state.origRequestedMaxCharge)  === parseFloat(this.state.requestedMaxCharge))  &&
           (parseFloat(this.state.origRequestedFloatLimit) === parseFloat(this.state.requestedFloatLimit)) &&
           (this.state.origMaxMonthlyBudget                === this.state.maxMonthlyBudget) ) {
        return true;
      }
    }

    if (isUserAppbind) {
      if ( (parseFloat(this.state.origMaxCharge)  === parseFloat(this.state.maxCharge))  &&
           (parseFloat(this.state.origFloatLimit) === parseFloat(this.state.floatLimit))) {
        return true;
      }
    }

    return false;
  }

  toggleSetMonthlyBudget(mmb) {
    if (mmb == null) {
      // Turn on a budget
      if (this.state.origMaxMonthlyBudget != null) {
        this.setState({ maxMonthlyBudget: this.state.origMaxMonthlyBudget});
      } else {
        // Do double of whatever the replenishment target is
        if (this.state.replenishAmount != null) {
          let theMmb = this.state.replenishAmount * 2;
          this.setState({ maxMonthlyBudget: theMmb});
        } else {
          this.setState({ maxMonthlyBudget: 500.00});
        }
      }
    } else {
      // Turn off the budget
      this.setState({maxMonthlyBudget: null});
    }
  }

  render() {
    const classes = this.props.classes;
    
    const { logError } = this.props.auth;

    let acctId = this.props.accountId;

    //here we need to figure out if the user is one of us but NOT masquarading.
    let isUserAppbind = (abEnvironment.getUserAttribute("role") === "appbind_appbind");

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={CustomerChargeLimitQuery}
        variables={{accountId: acctId,
                    activeOnly: 1,
                    purpose: 0,
                    refetch: this.state.doRefreshCount}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {

            if (!this.state.accountFetched) { 

              return (
                <div>
                  <LoadingSpinner/>
                </div>
              );
      
            } else {
            
              let currentRequestedFloatLimit = Number(this.state.requestedFloatLimit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 0})
              let currentRequestedMaxCharge  = Number(this.state.requestedMaxCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 0})

              let theMaxChargeLabel  = Number(this.state.maxCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 0});
              let theFloatLimitLabel = Number(this.state.floatLimit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 0});

              let chargeMarks = [
                {
                  value: 0,
                  label: '$0',
                },
                {
                  value: this.state.maxCharge,
                  label: theMaxChargeLabel,
                },
              ];

              let floatMarks = [
                {
                  value: 0,
                  label: '$0',
                },
                {
                  value: this.state.floatLimit,
                  label: theFloatLimitLabel,
                },
              ];

              /* budget */
              return (
                <React.Fragment>
                    <Paper className={classes.paper}>
                      <Grid container spacing={2} direction="row" >
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Grid container spacing={0}>
                                <Grid item xs={12}>
                                  <Typography align="left" variant="h6">Manage charge limits</Typography>
                                </Grid>
              
                                <Grid item xs={12}>
                                  <Typography variant="body2">{"Set maximum charge and float limits"}</Typography>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid container spacing={2}>
                                    <DashboardLimitRequest auth={this.props.auth} accountId={acctId} maxCharge={this.state.requestedMaxCharge} floatLimit={this.state.requestedFloatLimit} limitOnly={1} showRequestButton={false}/>
                                  </Grid>
                                </Grid>

                                {/* AppBind admin user */}
                                {this.state.accountFetched && isUserAppbind &&
                                <React.Fragment>
                                  <Grid item xs={2}>
                                    <CurrencyTextField 
                                      id="maxCharge" label="Max charge"
                                      value={ this.state.maxCharge }
                                      onChange={ (e) => this.setState({ maxCharge: e.target.value }) }
                                      showErrMsg={true}
                                      allowNegative={false}
                                      minValue={0}
                                      minEnterValue={0}
                                      textAlign="right"
                                    />
                                  </Grid>
                                  <Grid item xs={2}>
                                    <CurrencyTextField 
                                      id="float-limit" label="Float limit"
                                      value={ this.state.floatLimit }
                                      onChange={ (e) => this.setState({ floatLimit: e.target.value }) }
                                      showErrMsg={true}
                                      allowNegative={false}
                                      minValue={0}
                                      minEnterValue={0}
                                      textAlign="right"
                                    />
                                  </Grid>
                                </React.Fragment>
                                }


                                <Grid item xs={12} style={{marginTop: '16px'}}>
                                  <Grid container spacing={1} direction="row" >
                                    {this.state.accountFetched && !isUserAppbind &&
                                    <React.Fragment>
                                      <Grid item xs={12}>
                                        <Grid container spacing={0}>
                                          <Grid item><Typography variant="body1">{"Maximum charge ("  +  currentRequestedMaxCharge + ')'}</Typography></Grid>
                                          <Grid item>
                                            <Tooltip placement='bottom' title={"This is the maximum individual subscription charge amount that AppBind will authorize for this customer."}>
                                              <HelpOutline fontSize="small" style={{verticalAlign: "-6%", marginLeft: '4px'}}/>         
                                            </Tooltip>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid item xs={12} style={{marginRight: '8px'}}>
                                        <Slider valueLabelFormat={ValueLabelFormat} 
                                                defaultValue={this.state.requestedMaxCharge} 
                                                max={this.state.maxCharge} 
                                                valueLabelDisplay="auto" 
                                                onChange={this.handleRequestedMaxChargeChange} 
                                                marks={chargeMarks}
                                                aria-labelledby="continuous-slider" />
                                      </Grid>
                                      
                                      <Grid item xs={12}>
                                        <Grid container spacing={0}>
                                          <Grid item><Typography variant="body1">{"Float limit ("  +  currentRequestedFloatLimit + ')'}</Typography></Grid>
                                          <Grid item>
                                            <Tooltip placement='bottom' title={"The float limit is the maximum amount of total outstanding charges that are allowed for this customer. Any charge that will result in the total float exceeding this limit will be declined."}>
                                              <HelpOutline fontSize="small" style={{verticalAlign: "-6%", marginLeft: '4px'}}/>         
                                            </Tooltip>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid item xs={12} style={{marginRight: '8px'}}>
                                        <Slider valueLabelFormat={ValueLabelFormat} 
                                                defaultValue={this.state.requestedFloatLimit} 
                                                max={this.state.floatLimit} 
                                                valueLabelDisplay="auto" 
                                                onChange={this.handleRequestedFloatLimitChange} 
                                                marks={floatMarks}
                                                aria-labelledby="continuous-slider" />
                                      </Grid>
                                    </React.Fragment>
                                    }


                                    <Grid item xs={12}>
                                      <SaveButton
                                      snackbarOpen={this.state.saveSnackbarOpenLimit}
                                      autoHideDuration={this.state.saveSnackbarDurationLimit}
                                      onSaveClick={() => { this._updateAccountLimits(isUserAppbind); }}
                                      onSnackbarClose={() => { this._onSnackbarClose(); }}
                                      status={this.state.saveStatusLimit}
                                      message={this.state.saveMessageLimit}
                                      disabled={this.isLimitSaveDisabled(isUserAppbind)}
                                      />
                                    
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>
                
                  {this.props.auth.isUnauthenticatedCustomer() && false &&
                  <Grid container direction="row" justifyContent="center" alignItems="center">
                    <PoweredBy/>
                  </Grid>
                  }
                </React.Fragment>
              );
            }
          }
          return <div><LoadingSpinner/></div>
        }}
      />
    );
  }
  
  _onSnackbarClose() {
    this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null, 
    saveSnackbarOpenLimit: false, saveStatusLimit: '', saveMessageLimit: '', saveSnackbarDurationLimit: null,
    saveSnackbarOpenPFB: false, saveStatusPFB: '', saveMessagePFB: '', saveSnackbarDurationPFB: null,
    saveSnackbarOpenAddNow: false, saveStatusAddNow: '', saveMessageAddNow: '', saveSnackbarDurationAddNow: null });
  }

  _updateAccountLimits(isUserAppbind) {
    let accountId = this.props.accountId

    this.setState({ saveStatusLimit: 'saving' });
    const { maxCharge, floatLimit, requestedMaxCharge,  requestedFloatLimit, maxMonthlyBudget, useBudgets } = this.state;

    if (!isUserAppbind) {

      AutoTopupAccountUpdateMutation.commit(accountId, null, null, null, null, requestedMaxCharge, requestedFloatLimit, null, null, null, true, maxMonthlyBudget, useBudgets, null)
      .then(response => {
        // console.log('Account updated')
        this.setState({ saveSnackbarOpenLimit: true, saveStatusLimit: 'success', saveMessageLimit: 'Account updated', saveSnackbarDurationLimit: 3000,
                        origRequestedMaxCharge: this.state.requestedMaxCharge, origRequestedFloatLimit: this.state.requestedFloatLimit, origMaxMonthlyBudget: this.state.maxMonthlyBudget
                  });
        

        })
      .catch(error => {
        // console.log('Got error: ' + error);
        this.setState({ saveSnackbarOpenLimit: true, saveStatusLimit: 'error', saveMessageLimit: 'Problem saving', saveSnackbarDurationLimit: null  });
      });
    } 

    if (isUserAppbind) {
      let newRequestMaxCharge = requestedMaxCharge;
      let newRequestedFloatLimit = requestedFloatLimit;

      if (parseFloat(newRequestMaxCharge) > parseFloat(maxCharge)) {
        newRequestMaxCharge = maxCharge;
      }
      if (parseFloat(newRequestedFloatLimit) > parseFloat(floatLimit)) {
        newRequestedFloatLimit = floatLimit;
      }

      AutoTopupAccountUpdateMutation.commit(accountId, null, null, null, null, newRequestMaxCharge, newRequestedFloatLimit, maxCharge, floatLimit, null, false, null, null, null)
      .then(response => {
        // console.log('Account updated')
        this.setState({ saveSnackbarOpenLimit: true, saveStatusLimit: 'success', saveMessageLimit: 'Account updated', saveSnackbarDurationLimit: 3000,
                        origMaxCharge: this.state.maxCharge, origFloatLimit: this.state.floatLimit,
                        origRequestedMaxCharge: newRequestMaxCharge, origRequestedFloatLimit: newRequestedFloatLimit,
                        requestedMaxCharge: newRequestMaxCharge, requestedFloatLimit: newRequestedFloatLimit,
                 });
        
  
       })
      .catch(error => {
        // console.log('Got error: ' + error);
        this.setState({ saveSnackbarOpenLimit: true, saveStatusLimit: 'error', saveMessageLimit: 'Problem saving', saveSnackbarDurationLimit: null  });
      });
    }

  }

}
  
CustomerChargeLimit.propTypes = {
    classes: PropTypes.object.isRequired,
  };
      
  export default withStyles(styleSheet)(CustomerChargeLimit);
